import { useHomeTrack } from "@/hooks/use-home-track";
import { motion } from "framer-motion";
import { PlayCircle } from "lucide-react";
import Image from "next/image";
import { Card, CardContent, CardHeader } from "../ui/card";

export default function TopViews({getTopViewedTracks}:{getTopViewedTracks:any}) {
  const {handleRedirect,t}= useHomeTrack()
  return (
    <motion.section
      aria-labelledby="top-views-heading"
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      
    >
      <Card className="p-4">
        <CardHeader>
          <h2 id="top-views-heading" className="text-xl font-bold text-primary">
            {t("top_views")}
          </h2>
        </CardHeader>
        <CardContent>
          <ul className="space-y-4">
            {getTopViewedTracks?.map((track: any, index: number) => (
              <li
                key={index}
                className="flex items-center space-x-4 bg-muted/10 hover:bg-muted p-2 rounded-md transition cursor-pointer"
                onClick={() => handleRedirect(track.type, track.slug)}
              >
                <Image
                  src={track.image?.url || "/placeholder.jpg"}
                  alt={track.title}
                  width={60}
                  height={60}
                  loader={({ src }) => src}
                  className="rounded-md object-cover"
                />
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-foreground truncate">
                    {track.title}
                  </p>
                  <p className="text-sm text-muted-foreground truncate">
                    {track.artist} ({track.type})
                  </p>
                </div>
                <PlayCircle className="text-primary w-6 h-6 hover:text-primary-foreground transition" />
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </motion.section>
  );
}
